import axios from 'admin/axios'
import { responseFormat, formatSelectOption as format } from '@/utils'
export { default as select } from './select'
export { default as bzmj } from './bzmj'
export { default as common } from './common'
export { default as report } from './report'

const loading = 'loading'

const post = (url, data, option) =>
  axios.post(url, data, option).then(({ data = {} }) => data.data || {})

const cache = {}
/**
 * 获取token
 */
export const getToken = () => {
  if (cache.token) return cache.token
  cache.token = axios.get('/admin', {}, { responseType: 'text' }).then(({ data }) => {
    // if (/name="?token"?\s*content="?([^>\s"]+)"?/.test(data)) return RegExp.$1
    if (data.data) return data.data
    return ''
  }).finally(() => {
    delete cache.token
  })
  return cache.token
}
// 获取用户信息
export const getUserInfo = () => {
  if (cache.userinfo) return cache.userinfo
  cache.userinfo = post('/jkd/admin/login/user').finally(() => {
    delete cache.userinfo
  })
  return cache.userinfo
}

// 获取权限设置列表
export const permissionsList = () =>
  post('/jkd/admin/permissionsLevel', {}, { loading })
    .then(data => responseFormat.string2number(data, ['is_menu', 'level', 'parent_id', 'type', 'category', 'order'], true))

// 获取角色列表
export const roleList = data =>
  post('/jkd/admin/roleList', data, { loading, ...data })

// 获取某个角色的信息
export const getRoleInfo = data => axios.post('/jkd/admin/rolePermissions', data, { loading: 'role' }).then(res => {
  const { check_permission = '', ...data } = responseFormat.string2number(res.data.data, ['front', 'back', 'h5'], true)
  const check = check_permission ? check_permission.split(',').filter(i => i) : []
  return { ...data, check_permission: check }
})

// 获取角色列表下拉框
export const roleSelectList = data => axios.post('/jkd/admin/roleSelectList', data, { loading: 'roleselect' }).then(({ data = {} }) => format(data.data))

// 获取数据权限业务
export const businessTypeSelectList = data => {
  if (cache.business) return cache.business
  return (cache.business = axios.post('/jkd/admin/businessTypeList', data, { loading: 'business' }).then(({ data = {} }) => format(data.data, 'business_name'), () => (cache.business = null)))
}

// 获取数据权限 级别
export const dataTypeList = data => axios.post('/jkd/admin/dataTypeList', data, { loading: 'data_type' }).then(({ data = {} }) => format(data.data))

/**
 * 获取数据权限下拉
 * @param {string} business_type_id 业务类型
 * @param {string} level 数据权限级别
 */
export const getDataAuthList = (business_type_id, level) => {
  if (!business_type_id || !level) return Promise.resolve([])
  const key = `${business_type_id || 0}_${level}`
  if (cache[key]) return cache[key]
  return (cache[key] = axios.post('/jkd/admin/dataPermissionsList', { business_type_id, level }, { loading: 'data_auths' }).then(({ data = {} }) => format(data.data), () => (cache[key] = null)))
}

/**
 * 新增帐号
 */
export const addNewAccount = data => axios.post('/jkd/admin/users/createUser', data, { loading: 'save' }).then(({ data }) => data.message || '操作成功')

/**
 * 更新帐户状态
 */
export const updateAccountStatus = (uid, status) => axios.post('/jkd/admin/users/updateStatus', { uid, status }, { loading: 'updateaccount' }).then(({ data = {} }) => data.message || '操作成功')

/**
 * 编辑帐号
 */
export const modifyAccount = data => axios.post('/jkd/admin/users/changeUser', data, { loading: 'save' }).then(({ data }) => data.message || '操作成功')

// 获取业务类型
export const getBusinessType = () => post('/jkd/admin/businessTypeList', { type: 'all' }).then(data => data.map(item => ({ label: item.business_name, value: item.id })))

// 门店管理列表
export const dealerList = data => post('/jkd/admin/roleList', data, { loading })

// 门店管理新增
export const dealerAdd = data => post('/jkd/admin/roleList', data, { loading: 'dealerAdd' })

// 账号列表
export const accountList = data => post('/jkd/admin/users/userList', data, { loading })

// 获取角色组信息
export const getRoleGroups = () => post('/jkd/admin/userGroups')

export const API_SIGN_OUT = '/jkd/admin/logout'
export const API_SIGN_IN = '/jkd/admin/login'

export const API_QUERY_DEALER_PART = 'jkd/admin/dealersFilter' // 门店头部筛选条件
export const API_QUERY_DAQUE = 'jkd/admin/daquListGroupByBusiness' // 战区
/**
 * 门店管理-查询条件
 */
export const API_QUERY_LIST_DEALER = [
  API_QUERY_DEALER_PART,
  API_QUERY_DAQUE
]

/** ***************  区域走访工具 ******************* **/
/**
 * 上传体系文件
 */
export const uploadSystemFile = data => axios.post('/xj/admin/system/add', data, {
  headers: {
    'Content-Type': 'multipart/form-data;application/json;charset=UTF-8'
  },
  timeout: Infinity,
  loading: 'uploadsystemfile'
}).then(({ data = {} }) => data.message || '操作成功')

/**
 * 获取下拉列表
 */
export const xj_getSelect = data => {
  if (cache.select) return cache.select
  return (cache.select = post('/xj/admin/system/select', data, { loading: 'select' }).then(data => {
    const { type: task_type = {}, business_type = [] } = data
    const taskType = Object.keys(task_type).map(value => {
      return {
        label: task_type[value],
        value
      }
    })
    return {
      task_type,
      business_type: business_type.reduce((obj, { name, id }) => {
        obj[id] = name
        return obj
      }, {}),
      taskType,
      businessType: format(business_type)
    }
  }, () => (cache.select = null)))
}

/**
 * 获取帐号信息
 */
export const getAccountInfo = uid => axios.post('/jkd/admin/users/userInfo', { uid }, { loading: `account_${uid}` }).then(({ data = {} }) => data.data || { business_and_permission: [] })

/**
 * 体系列表
 */
export const xj_getSystemList = data => post('/xj/admin/system/list', data, { loading })

/**
 * 体系列表 - 状态切换（启用）
 */
export const xj_switchTaskStatus = data => post('/xj/admin/system/start', data, { loading })

/**
 * 体系详情
 */
export const xj_systemDetail = data => post('/xj/admin/system/detail', data, { loading })

/**
 * 获取战区 小区（下发任务专用）
 * @param {number} child_task_id
 */
export const getRegion = data =>
  axios.post('/bzmj/region', data, { loading: 'region' }).then(({ data = {} }) => {
    const { daqu_name = [], xiaoqu_name = [] } = data.data || {}
    const daquList = daqu_name.map(({ id: value, name: label }) => ({ label, value }))
    const xiaoquList = xiaoqu_name.map(({ id: value, name: label, daqu_id }) => ({ label, value, daqu_id }))
    return { daquList, xiaoquList }
  })

/**
 * 重置密码
 * @param {string} uid
 */
export const resetPasswrod = uid => axios.post('/admin/user/save/resetpass', { uid }, { loading: 'resetpwd' }).then(({ data = {} }) => data.message || '操作成功')

/**
 * 在线用户列表
 */
export const getOnlineUsers = data => axios.post('/admin/online/onlineUserList', data, { loading }).then(({ data = {} }) => {
  const { list = [], pages } = data.data || {}
  const { counts: total = 0 } = pages || {}
  return { list, total }
})

/**
 * 强制下线
 */
export const kickOutUser = (type, uid, session_id) => axios.post('/admin/online/offlineUser', { type, uid, session_id }, { loading: 'kickout' }).then(({ data = {} }) => data.message || '操作成功')

/**
 * 下线操作日志
 */
export const kickOutLogs = data => axios.post('/admin/online/offlineLogs', data, { loading: 'log' }).then(({ data = {} }) => {
  const { list = [], pages } = data.data || {}
  const { counts: total = 0 } = pages || {}
  return { list, total }
})
